import React, { useState } from 'react';
import UserManagement from './UserManagement';
import AdminCrudPanel from './AdminCrudPanel';
import './AdminPortal.css';

const TABS = [
  { key: 'users', label: 'Users' },
  { key: 'userAssociations', label: 'User Associations' },
  { key: 'rbac', label: 'RBAC' },
  { key: 'components', label: 'Components' },
  { key: 'accounts', label: 'Accounts' },
  { key: 'applications', label: 'Applications' },
];

function AdminPortal() {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="admin-portal page-surface">
      <div className="admin-portal-header">
        <h2>Admin Portal</h2>
        <p>Manage IAS entities from one place with internal CRUD tabs.</p>
      </div>

      <div className="admin-tabs" role="tablist" aria-label="Admin tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`admin-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-tab-content">
        {activeTab === 'users' && <UserManagement />}
        {activeTab === 'userAssociations' && <AdminCrudPanel domain="userAssociations" />}
        {activeTab === 'rbac' && <AdminCrudPanel domain="rbac" />}
        {activeTab === 'components' && <AdminCrudPanel domain="components" />}
        {activeTab === 'accounts' && <AdminCrudPanel domain="accounts" />}
        {activeTab === 'applications' && <AdminCrudPanel domain="applications" />}
      </div>
    </div>
  );
}

export default AdminPortal;
